import React from "react";
import styled from "styled-components";
import { iconPaths } from "./icon-paths";
import type { IconName } from "./icon-paths";

export type { IconName };

/** Tokened icon colours, plus an opt-out that inherits the parent's `color`. */
export type V3IconColor =
  | "primary"
  | "secondary"
  | "tertiary"
  | "brand"
  | "success"
  | "error"
  | "warning"
  | "inverse"
  | "currentColor";

export interface V3IconProps {
  name: IconName;
  size?: number;
  color?: V3IconColor;
  /** Accessible name. Omit for decorative icons — they are hidden from AT. */
  title?: string;
  className?: string;
  testID?: string;
}

const Svg = styled.svg<{ $color: V3IconColor }>`
  display: inline-block;
  flex: none;
  vertical-align: middle;
  color: ${({ theme, $color }) =>
    $color === "currentColor" ? "inherit" : theme.colors.ui.icon[$color]};
`;

export const V3Icon = ({
  name,
  size = 20,
  color = "currentColor",
  title,
  className,
  testID,
}: V3IconProps): JSX.Element => {
  const { viewBox, children } = iconPaths[name];
  const labelled = title !== undefined && title !== "";

  return (
    <Svg
      $color={color}
      viewBox={viewBox}
      width={size}
      height={size}
      fill="currentColor"
      focusable="false"
      role={labelled ? "img" : undefined}
      aria-label={labelled ? title : undefined}
      aria-hidden={labelled ? undefined : true}
      className={className}
      data-icon={name}
      data-testid={testID ?? `icon-${name}`}
    >
      {labelled ? <title>{title}</title> : null}
      {children}
    </Svg>
  );
};
